
import { ScrollArea } from "@/components/ui/scroll-area";
import SidebarItem from "./SidebarItem";
import { SidebarRouteItem } from "./sidebarRoutes";

interface DesktopSidebarProps {
  authorizedRoutes: SidebarRouteItem[];
}

const DesktopSidebar = ({ authorizedRoutes }: DesktopSidebarProps) => {
  return (
    <div className="hidden md:flex h-screen w-64 flex-col border-r bg-background">
      <ScrollArea className="flex-1 p-4">
        <div className="flex flex-col gap-1">
          {authorizedRoutes.map((route) => (
            <SidebarItem
              key={route.href}
              title={route.title}
              icon={route.icon}
              href={route.href}
            />
          ))}
        </div>
      </ScrollArea>
    </div>
  );
};

export default DesktopSidebar;
